<template>
  <div class="colorPickerSlide">
    <div class="currentColorGrid">
      <span>当前颜色</span>
      <div
        class="currentColorDom"
        :style="{'background-color':currentColor}"
        @click="openColorPicker($event, { whichPart: 'bgSlide_ColorPicker' })"
      >
        <div :class="{'noCurrentColor':!currentColor}"></div>
      </div>
    </div>
    <div class="colorGrid" v-if="BrandColor && BrandColor.length>0">
      <span>品牌颜色</span>
      <ul>
        <li v-for="(item,index) in BrandColor" :key="index" @click="setSolidColor(item.color)">
          <div class="colorItem" :style="{'background-color':item.color}"></div>
        </li>
      </ul>
    </div>
    <div class="colorGrid">
      <span>默认颜色</span>
      <ul>
        <li v-for="(item,index) in solidColors" :key="index" @click="setSolidColor(item)">
          <div class="colorItem" :style="{'background-color':item}"></div>
        </li>
      </ul>
    </div>
    <div class="colorGrid" v-if="boxName=='bg'&&gradients.length>0">
      <span>渐变色</span>
      <ul>
        <li v-for="(item,index) in gradients" :key="index" @click="setGradient(item)">
          <div
            class="colorItem"
            :style="{ background:'url('+$handleAssetsUrl(item.thumbnailUrl)+') center/cover no-repeat'}"
          ></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import colorsTable from "../../mixins/colorsTable";

export default {
  name: "colorPicker",
  mixins: [colorsTable],
  data() {
    return {
      currentColor: "#ffffff",
      //brandColors: [],
      gradients: []
    };
  },
  props: {
    boxName: ""
  },
  components: {},
  methods: {
    // getBrandColor() {
    //   let url = "/api/user/brand/color";
    //   this.$http.get(url).then(res => {
    //     if (res.data.code === 200) {
    //       this.brandColors = res.data.data;
    //       //console.log(JSON.stringify(this.brandColors));
    //     }
    //   });
    // },
    getGradients() {
      let url =
        "/api/common/material?type=3&bgType=2&fPage=999&sOfPage=999&pIndex=1";
      this.$http.get(url).then(res => {
        if (res.data.code == 200) {
          this.gradients = res.data.data;
        }
      });
    },
    setSolidColor(item) {
      this.currentColor = item;
      this.$emit("colorChanged", { type: "Solid", color: item });
    },
    setGradient(item) {
      this.$emit("colorChanged", { type: "Gradient", url: item.url });
    },
    openColorPicker(e, { whichPart } = {}) {
      let rect = e.target.getBoundingClientRect();
      this.$bus.emit("FeaturesPop_vue", {
        name: "color",
        type: 1,
        posx: rect.left - 50,
        posy: rect.top + 30,
        whichPart,
        color: this.currentColor
      });
    },
    colorPickerInput(obj, { type }) {
      if (type === "bgSlide_ColorPicker") {
        this.setSolidColor(obj.hex || "");
      }
    }
  },
  watch: {
    "SelectScenes_Msg.background.data"(val) {
      if (val.type == "Color") {
        this.currentColor = val.data.color;
      } else {
        this.currentColor = "#ffffff";
      }
    }
  },
  mounted() {
    //this.getBrandColor();
    this.getGradients();
    this.$bus.on("colorPickerInput.picker", this.colorPickerInput);
  },
  computed: {
    ...mapGetters(["SelectScenes_Msg", "BrandColor"])
  }
};
</script>

<style scoped lang="scss">
.colorPickerSlide {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
}
.currentColorGrid {
  position: relative;
  .currentColorDom {
    margin-top: 12px;
    width: 40px;
    height: 32px;
    border-radius: 4px;

    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #d9ddea;
    > div {
      //position: absolute;
      width: 8px;
      height: 8px;
      border-left: 1px solid #d9ddea;
      border-bottom: 1px solid #d9ddea;
      transform: rotate(-45deg);
      margin: 0 auto;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .noCurrentColor {
    border-color: #d9ddea;
  }
  > span {
    display: block;
    text-align: left;
    font-size: 14px;
    color: #474261;
  }
}
.colorGrid {
  margin-top: 18px;
  overflow: hidden;
  > span {
    display: block;
    text-align: left;
    font-size: 14px;
    color: #474261;
  }
  > ul {
    max-height: 206px;
    width: 300px;
    overflow-y: scroll;
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    > li {
      margin-right: 6px;
      margin-bottom: 6px;
      &:hover {
        cursor: pointer;
      }
    }
    > li:nth-child(6n) {
      margin-right: 0;
    }
  }
  .colorItem {
    width: 40px;
    height: 32px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #d9ddea;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/rightnav/slide/colorPickerSlide.vue